import { createSlice } from "@reduxjs/toolkit";
import { formSettings as initialState } from "../initialState";
import {
    selectInjectionDataSelector,
    selectSpecificFormSettingSelector,
} from "../selectors/formSettingsSelectors";

export const slice = createSlice({
    name: "formSettings",
    initialState,
    reducers: {
        setFormSettings: (state, action) => action.payload,
    },
});

// actions
export const { setFormSettings } = slice.actions;

// selectors
export const selectAllFormSettings = (state) => state.formSettings;

// header or footer injections
export const selectInjectionData = (state, dataLocation) =>
    selectInjectionDataSelector(state, dataLocation);

// Good for when you only need one key
export const selectSpecificFormSetting = (state, settingName) =>
    selectSpecificFormSettingSelector(state, settingName);

export default slice.reducer;
